const pillWidth = () => {
	if (document.querySelectorAll('.pill-buttons').length) {
		let btnWidth = document.querySelector('button.pill-button.active').offsetWidth;

		document.querySelector('.button-slider').style.width = btnWidth + 'px';
	}
}

export default pillWidth;